import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './UserPicks.css';
import { useSeason } from '../SeasonContext';
import { fetchUserPicks } from '../api';

const UserPicks = () => {
  const { season } = useSeason();
  const [error, setError] = useState('');
  const { userId } = useParams();
  const [picks, setPicks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setPicks([]);
    setError('');
    fetchUserPicks(userId, season)
      .then(data => { if (active) setPicks(data); })
      .catch(err => { if (active) setError(err.message); })
      .finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; };
  }, [userId, season]);

  return (
    <div className="user-picks">
      <h1>OIM FANTASY {season}</h1>
    <h2>{userId}'s Picks</h2>

    {error && <p role="alert">{error}</p>}
    {/* The Picks Header */}
    <div className="user-picks-table">
      {isLoading ? (
        <div className="loading-state" role="status" aria-live="polite">
          <div className="loading-spinner" />
          <span>Loading picks…</span>
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Week</th>
              <th>Pick</th>
              <th>Odds</th>
              <th>Result</th>
            </tr>
          </thead>

          {/* The actual picks per OIM */}
          <tbody>
            {picks.map((pick, index) => (
              <tr key={index}>
                <td className="week">{pick.weekNum}</td>
                <td className="pick">{pick.pick}</td>
                <td className="odds">{pick.odds}</td>
                <td className="result">{pick.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
  );
};

export default UserPicks;